import { ExistingPromos } from "./ExistingPromos"
import { AddPromo } from "./AddPromo"

type TAccountPromosProps = {
  account_id: string
}

export const AccountPromos = ({ account_id }: TAccountPromosProps) => {
  return (
    <div className="tw:grid tw:grid-cols-2 tw:gap-2 tw:divide-x tw:divide-gray-200">
      <ExistingPromos account_id={account_id} />
      <AddPromo account_id={account_id} />
    </div>
  )
}
